<div class="system-thumbnail" (click)="openSystemInNewTab()">
  <img [src]="systemImageUrl()" [alt]="system().modelName" />
  <span>{{ system().modelName }}</span>
</div>
